// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { RoutePatterns } from '../../types/routes';

export default (pathname: string): boolean => {
  return matchPath(pathname, { path: RoutePatterns.HISTORY, exact: true }) !== null;
};
